{
  "colors": {
    "background": "hsl(var(--background) / <alpha-value>)",
    "foreground": "hsl(var(--foreground) / <alpha-value>)",
    "card": "hsl(var(--card) / <alpha-value>)",
    "card-foreground": "hsl(var(--card-foreground) / <alpha-value>)",
    "popover": "hsl(var(--popover) / <alpha-value>)",
    "popover-foreground": "hsl(var(--popover-foreground) / <alpha-value>)",
    "primary": "hsl(var(--primary) / <alpha-value>)",
    "primary-foreground": "hsl(var(--primary-foreground) / <alpha-value>)",
    "primary-hover": "hsl(var(--primary-hover) / <alpha-value>)",
    "primary-pressed": "hsl(var(--primary-pressed) / <alpha-value>)",
    "secondary": "hsl(var(--secondary) / <alpha-value>)",
    "secondary-foreground": "hsl(var(--secondary-foreground) / <alpha-value>)",
    "muted": "hsl(var(--muted) / <alpha-value>)",
    "muted-foreground": "hsl(var(--muted-foreground) / <alpha-value>)",
    "accent": "hsl(var(--accent) / <alpha-value>)",
    "accent-foreground": "hsl(var(--accent-foreground) / <alpha-value>)",
    "destructive": "hsl(var(--destructive) / <alpha-value>)",
    "destructive-foreground": "hsl(var(--destructive-foreground) / <alpha-value>)",
    "border": "hsl(var(--border) / <alpha-value>)",
    "border-subtle": "hsl(var(--border-subtle) / <alpha-value>)",
    "input": "hsl(var(--input) / <alpha-value>)",
    "ring": "hsl(var(--ring) / <alpha-value>)",
    "copy": "hsl(var(--copy) / <alpha-value>)",
    "copy-muted": "hsl(var(--copy-muted) / <alpha-value>)",
    "foreground-secondary": "hsl(var(--foreground-secondary) / <alpha-value>)",
    "foreground-disabled": "hsl(var(--foreground-disabled) / <alpha-value>)",
    "sunken": "hsl(var(--sunken) / <alpha-value>)",
    "selected": "hsl(var(--selected) / <alpha-value>)",
    "message-user": "hsl(var(--message-user) / <alpha-value>)",
    "message-agent": "hsl(var(--message-agent) / <alpha-value>)",
    "link": "hsl(var(--link) / <alpha-value>)",
    "heading-accent": "hsl(var(--heading-accent) / <alpha-value>)",
    "heading-title": "hsl(var(--heading-title) / <alpha-value>)",
    "brand-accent": "hsl(var(--brand-accent) / <alpha-value>)",
    "backdrop": "hsl(var(--backdrop) / <alpha-value>)",
    "success": "hsl(var(--success) / <alpha-value>)",
    "success-text": "hsl(var(--success-text) / <alpha-value>)",
    "success-subtle": "hsl(var(--success-subtle) / <alpha-value>)",
    "success-border": "hsl(var(--success-border) / <alpha-value>)",
    "success-solid": "hsl(var(--success-solid) / <alpha-value>)",
    "success-solid-foreground": "hsl(var(--success-solid-foreground) / <alpha-value>)",
    "warning": "hsl(var(--warning) / <alpha-value>)",
    "warning-text": "hsl(var(--warning-text) / <alpha-value>)",
    "warning-subtle": "hsl(var(--warning-subtle) / <alpha-value>)",
    "warning-border": "hsl(var(--warning-border) / <alpha-value>)",
    "warning-solid": "hsl(var(--warning-solid) / <alpha-value>)",
    "warning-solid-foreground": "hsl(var(--warning-solid-foreground) / <alpha-value>)",
    "error": "hsl(var(--error) / <alpha-value>)",
    "error-text": "hsl(var(--error-text) / <alpha-value>)",
    "error-subtle": "hsl(var(--error-subtle) / <alpha-value>)",
    "error-border": "hsl(var(--error-border) / <alpha-value>)",
    "error-solid": "hsl(var(--error-solid) / <alpha-value>)",
    "error-solid-foreground": "hsl(var(--error-solid-foreground) / <alpha-value>)",
    "info": "hsl(var(--info) / <alpha-value>)",
    "info-text": "hsl(var(--info-text) / <alpha-value>)",
    "info-subtle": "hsl(var(--info-subtle) / <alpha-value>)",
    "info-border": "hsl(var(--info-border) / <alpha-value>)",
    "info-solid": "hsl(var(--info-solid) / <alpha-value>)",
    "info-solid-foreground": "hsl(var(--info-solid-foreground) / <alpha-value>)",
    "chart-1": "hsl(var(--chart-1) / <alpha-value>)",
    "chart-2": "hsl(var(--chart-2) / <alpha-value>)",
    "chart-3": "hsl(var(--chart-3) / <alpha-value>)",
    "chart-4": "hsl(var(--chart-4) / <alpha-value>)",
    "chart-5": "hsl(var(--chart-5) / <alpha-value>)",
    "chart-6": "hsl(var(--chart-6) / <alpha-value>)"
  },
  "fontFamily": {
    "sans": [
      "Inter",
      "system-ui",
      "Segoe UI",
      "Roboto",
      "Arial",
      "sans-serif"
    ],
    "display": [
      "Outfit",
      "Inter",
      "system-ui",
      "Segoe UI",
      "Roboto",
      "Arial",
      "sans-serif"
    ],
    "mono": [
      "ui-monospace",
      "SFMono-Regular",
      "Menlo",
      "Monaco",
      "Consolas",
      "Liberation Mono",
      "Courier New",
      "monospace"
    ]
  },
  "fontSize": {
    "display": [
      "2.2857rem",
      {
        "lineHeight": "2.8571rem",
        "letterSpacing": "-0.02em",
        "fontWeight": "700"
      }
    ],
    "title-1": [
      "1.7143rem",
      {
        "lineHeight": "2.2857rem",
        "letterSpacing": "-0.01em",
        "fontWeight": "600"
      }
    ],
    "title-2": [
      "1.2857rem",
      {
        "lineHeight": "2rem",
        "letterSpacing": "-0.01em",
        "fontWeight": "600"
      }
    ],
    "body-reading": [
      "1.1429rem",
      {
        "lineHeight": "1.5714rem",
        "letterSpacing": "0em",
        "fontWeight": "400"
      }
    ],
    "chat": [
      "0.9286rem",
      {
        "lineHeight": "1.2857rem",
        "letterSpacing": "0em",
        "fontWeight": "400"
      }
    ],
    "body": [
      "1rem",
      {
        "lineHeight": "1.5714rem",
        "letterSpacing": "0em",
        "fontWeight": "400"
      }
    ],
    "label": [
      "0.9286rem",
      {
        "lineHeight": "1.2857rem",
        "letterSpacing": "0em",
        "fontWeight": "500"
      }
    ],
    "caption": [
      "0.8571rem",
      {
        "lineHeight": "1.1429rem",
        "letterSpacing": "0em",
        "fontWeight": "400"
      }
    ],
    "micro": [
      "0.7857rem",
      {
        "lineHeight": "1rem",
        "letterSpacing": "0em",
        "fontWeight": "500"
      }
    ],
    "code": [
      "0.9286rem",
      {
        "lineHeight": "1.4286rem",
        "letterSpacing": "0em",
        "fontWeight": "400"
      }
    ]
  },
  "borderRadius": {
    "lg": "0.5714rem",
    "md": "0.4286rem",
    "sm": "0.2857rem"
  },
  "boxShadow": {
    "sm": "var(--shadow-sm)",
    "md": "var(--shadow-md)",
    "lg": "var(--shadow-lg)",
    "DEFAULT": "var(--shadow-md)",
    "xl": "var(--shadow-lg)"
  },
  "ringWidth": {
    "DEFAULT": "2px"
  },
  "ringOffsetWidth": {
    "DEFAULT": "2px"
  },
  "markdown": {
    ".md-h1": {
      "fontFamily": "Outfit, Inter, system-ui, 'Segoe UI', Roboto, Arial, sans-serif",
      "fontSize": "1.6em",
      "lineHeight": "1.2",
      "fontWeight": "700",
      "letterSpacing": "-0.02em",
      "color": "hsl(var(--heading-title))",
      "marginTop": "0.6em",
      "marginBottom": "0.3em"
    },
    ".md-h2": {
      "fontFamily": "Outfit, Inter, system-ui, 'Segoe UI', Roboto, Arial, sans-serif",
      "fontSize": "1.3em",
      "lineHeight": "1.25",
      "fontWeight": "600",
      "letterSpacing": "-0.01em",
      "color": "hsl(var(--heading-accent))",
      "marginTop": "0.6em",
      "marginBottom": "0.4em",
      "paddingBottom": "0.2em",
      "borderBottom": "1px solid hsl(var(--border-subtle))"
    },
    ".md-h3": {
      "fontFamily": "Inter, system-ui, 'Segoe UI', Roboto, Arial, sans-serif",
      "fontSize": "1.08em",
      "lineHeight": "1.3",
      "fontWeight": "600",
      "color": "hsl(var(--foreground))",
      "marginTop": "0.7em",
      "marginBottom": "0.25em"
    },
    ".md-h4": {
      "fontFamily": "Inter, system-ui, 'Segoe UI', Roboto, Arial, sans-serif",
      "fontSize": "0.78em",
      "lineHeight": "1.4",
      "fontWeight": "600",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase",
      "color": "hsl(var(--copy-muted))",
      "marginTop": "1em",
      "marginBottom": "0.3em"
    },
    ".md-h5": {
      "fontFamily": "Inter, system-ui, 'Segoe UI', Roboto, Arial, sans-serif",
      "fontSize": "0.78em",
      "lineHeight": "1.4",
      "fontWeight": "600",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase",
      "color": "hsl(var(--copy-muted))",
      "marginTop": "1em",
      "marginBottom": "0.3em"
    },
    ".md-h6": {
      "fontFamily": "Inter, system-ui, 'Segoe UI', Roboto, Arial, sans-serif",
      "fontSize": "0.78em",
      "lineHeight": "1.4",
      "fontWeight": "500",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase",
      "color": "hsl(var(--copy-muted))",
      "marginTop": "1em",
      "marginBottom": "0.3em"
    },
    ".md-p": {
      "marginBottom": "0.55em"
    },
    ".md-strong": {
      "fontWeight": "600",
      "color": "hsl(var(--foreground))"
    },
    ".md-em": {
      "fontStyle": "italic",
      "color": "hsl(var(--foreground))"
    },
    ".md-quote-inline": {
      "color": "hsl(var(--foreground))"
    },
    ".md-del": {
      "textDecorationLine": "line-through",
      "textDecorationColor": "hsl(var(--copy-muted))",
      "color": "hsl(var(--copy-muted))"
    },
    ".md-link": {
      "color": "hsl(var(--link))",
      "textDecorationLine": "underline",
      "textDecorationColor": "hsl(var(--link) / 0.4)",
      "textUnderlineOffset": "0.15em"
    },
    ".md-link:hover": {
      "textDecorationColor": "hsl(var(--link))"
    },
    ".md-link-external": {
      "fontSize": "0.8em",
      "color": "hsl(var(--copy-muted))",
      "paddingLeft": "0.15em"
    },
    ".md-autolink": {
      "overflowWrap": "anywhere"
    },
    ".md-footnote-ref": {
      "fontSize": "0.75em",
      "lineHeight": "0",
      "color": "hsl(var(--link))",
      "paddingLeft": "0.1em"
    },
    ".md-footnotes": {
      "fontSize": "0.85em",
      "color": "hsl(var(--copy-muted))",
      "marginTop": "1.2em",
      "paddingTop": "0.6em",
      "borderTop": "1px solid hsl(var(--border-subtle))"
    },
    ".md-footnotes-title": {
      "fontFamily": "Inter, system-ui, 'Segoe UI', Roboto, Arial, sans-serif",
      "fontSize": "0.85em",
      "fontWeight": "600",
      "letterSpacing": "0.06em",
      "textTransform": "uppercase",
      "color": "hsl(var(--copy-muted))",
      "marginBottom": "0.4em"
    },
    ".md-list": {
      "paddingLeft": "1.25em",
      "marginBottom": "0.55em"
    },
    ".md-li": {
      "lineHeight": "1.45",
      "marginTop": "0.25em"
    },
    ".md-li > .md-list": {
      "marginTop": "0.2em",
      "marginBottom": "0"
    },
    ".md-ul": {
      "listStyleType": "disc"
    },
    ".md-ul .md-ul": {
      "listStyleType": "circle"
    },
    ".md-ul .md-ul .md-ul": {
      "listStyleType": "square"
    },
    ".md-ul > .md-li::marker": {
      "color": "hsl(var(--brand-accent))"
    },
    ".md-ol": {
      "listStyleType": "decimal"
    },
    ".md-ol > .md-li::marker": {
      "color": "hsl(var(--brand-accent))",
      "fontWeight": "500",
      "fontVariantNumeric": "tabular-nums"
    },
    ".md-task-list": {
      "listStyleType": "none",
      "paddingLeft": "0.1em"
    },
    ".md-task-item": {
      "display": "flex",
      "alignItems": "baseline",
      "gap": "0.5em"
    },
    ".md-task-item[data-checked=\"true\"]": {
      "color": "hsl(var(--copy-muted))",
      "textDecorationLine": "line-through"
    },
    ".md-task-checkbox": {
      "accentColor": "hsl(var(--primary))",
      "width": "1em",
      "height": "1em",
      "flexShrink": "0",
      "transform": "translateY(0.15em)"
    },
    ".md-blockquote": {
      "fontStyle": "italic",
      "color": "hsl(var(--copy))",
      "backgroundColor": "hsl(var(--brand-accent) / 0.05)",
      "borderRadius": "0 0.4286rem 0.4286rem 0",
      "paddingTop": "0.5em",
      "paddingBottom": "0.5em",
      "paddingLeft": "0.85em",
      "paddingRight": "0.85em",
      "marginTop": "0.75em",
      "marginBottom": "0.75em",
      "borderLeft": "2px solid hsl(var(--brand-accent))"
    },
    ".md-blockquote .md-blockquote": {
      "backgroundColor": "transparent",
      "marginTop": "0.4em",
      "marginBottom": "0"
    },
    ".md-alert": {
      "fontStyle": "normal",
      "color": "hsl(var(--copy))",
      "borderRadius": "0 0.4286rem 0.4286rem 0",
      "paddingTop": "0.55em",
      "paddingBottom": "0.6em",
      "paddingLeft": "0.85em",
      "paddingRight": "0.85em",
      "marginTop": "0.75em",
      "marginBottom": "0.75em",
      "borderLeftStyle": "solid",
      "borderLeftWidth": "2px"
    },
    ".md-alert-title": {
      "display": "flex",
      "alignItems": "center",
      "gap": "0.4em",
      "fontSize": "0.85em",
      "fontWeight": "600",
      "marginBottom": "0.3em"
    },
    ".md-alert-note": {
      "backgroundColor": "hsl(var(--info-subtle))",
      "borderLeftColor": "hsl(var(--info-border))"
    },
    ".md-alert-note .md-alert-title": {
      "color": "hsl(var(--info-text))"
    },
    ".md-alert-tip": {
      "backgroundColor": "hsl(var(--success-subtle))",
      "borderLeftColor": "hsl(var(--success-border))"
    },
    ".md-alert-tip .md-alert-title": {
      "color": "hsl(var(--success-text))"
    },
    ".md-alert-important": {
      "backgroundColor": "hsl(var(--chart-1) / 0.1)",
      "borderLeftColor": "hsl(var(--chart-1))"
    },
    ".md-alert-important .md-alert-title": {
      "color": "hsl(var(--chart-1))"
    },
    ".md-alert-warning": {
      "backgroundColor": "hsl(var(--warning-subtle))",
      "borderLeftColor": "hsl(var(--warning-border))"
    },
    ".md-alert-warning .md-alert-title": {
      "color": "hsl(var(--warning-text))"
    },
    ".md-alert-caution": {
      "backgroundColor": "hsl(var(--error-subtle))",
      "borderLeftColor": "hsl(var(--error-border))"
    },
    ".md-alert-caution .md-alert-title": {
      "color": "hsl(var(--error-text))"
    },
    ".md-code-inline": {
      "fontFamily": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
      "fontSize": "0.9em",
      "color": "hsl(var(--foreground))",
      "backgroundColor": "hsl(var(--sunken))",
      "borderRadius": "0.2857rem",
      "paddingTop": "0.1em",
      "paddingBottom": "0.1em",
      "paddingLeft": "0.35em",
      "paddingRight": "0.35em"
    },
    ".md-code-block": {
      "backgroundColor": "hsl(var(--sunken))",
      "borderRadius": "0.4286rem",
      "marginTop": "0.75em",
      "marginBottom": "0.75em",
      "overflow": "hidden"
    },
    ".md-code-block-header": {
      "display": "flex",
      "alignItems": "center",
      "justifyContent": "space-between",
      "paddingTop": "0.4em",
      "paddingLeft": "0.85em",
      "paddingRight": "0.5em"
    },
    ".md-code-block-label": {
      "fontFamily": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace",
      "fontSize": "0.8em",
      "color": "hsl(var(--muted-foreground))",
      "textTransform": "lowercase"
    },
    ".md-code-block-unclosed": {
      "fontFamily": "Inter, system-ui, 'Segoe UI', Roboto, Arial, sans-serif",
      "fontSize": "0.8em",
      "color": "hsl(var(--warning-text))",
      "paddingLeft": "0.6em"
    },
    ".md-code-block-copy": {
      "fontSize": "0.8em",
      "color": "hsl(var(--muted-foreground))",
      "borderRadius": "0.2857rem",
      "paddingTop": "0.1em",
      "paddingBottom": "0.1em",
      "paddingLeft": "0.45em",
      "paddingRight": "0.45em"
    },
    ".md-code-block-copy:hover": {
      "color": "hsl(var(--foreground))",
      "backgroundColor": "hsl(var(--accent))"
    },
    ".md-code-block-body": {
      "paddingTop": "0.2em",
      "paddingBottom": "0.75em",
      "paddingLeft": "0.85em",
      "paddingRight": "0.85em"
    },
    ".md-table-wrap": {
      "overflowX": "auto",
      "borderRadius": "0.4286rem",
      "marginTop": "0.75em",
      "marginBottom": "0.75em"
    },
    ".md-table": {
      "width": "100%",
      "fontSize": "0.9em",
      "fontVariantNumeric": "tabular-nums",
      "borderCollapse": "separate",
      "borderSpacing": "0"
    },
    ".md-th": {
      "fontSize": "0.92em",
      "fontWeight": "600",
      "letterSpacing": "0.01em",
      "color": "hsl(var(--foreground))",
      "backgroundColor": "hsl(var(--foreground) / 0.05)",
      "whiteSpace": "nowrap",
      "textAlign": "left",
      "paddingTop": "0.5em",
      "paddingBottom": "0.5em",
      "paddingLeft": "0.75em",
      "paddingRight": "0.75em",
      "borderBottom": "1px solid hsl(var(--border))"
    },
    ".md-td": {
      "color": "hsl(var(--copy))",
      "verticalAlign": "top",
      "overflowWrap": "anywhere",
      "maxWidth": "28em",
      "paddingTop": "0.5em",
      "paddingBottom": "0.5em",
      "paddingLeft": "0.75em",
      "paddingRight": "0.75em",
      "borderBottom": "1px solid hsl(var(--border-subtle))"
    },
    ".md-td:first-child": {
      "fontWeight": "500",
      "color": "hsl(var(--foreground))"
    },
    ".md-tbody > .md-tr:nth-child(even)": {
      "backgroundColor": "hsl(var(--foreground) / 0.025)"
    },
    ".md-tbody > .md-tr:hover": {
      "backgroundColor": "hsl(var(--foreground) / 0.06)"
    },
    ".md-tbody > .md-tr:last-child > .md-td": {
      "borderBottomStyle": "solid",
      "borderBottomWidth": "0"
    },
    ".md-hr": {
      "marginTop": "1.2em",
      "marginBottom": "1.2em",
      "marginInline": "10%",
      "borderTop": "1px solid hsl(var(--border-subtle))"
    },
    ".md-figure": {
      "display": "block",
      "marginTop": "0.75em",
      "marginBottom": "0.75em"
    },
    ".md-img": {
      "display": "block",
      "maxWidth": "100%",
      "maxHeight": "28em",
      "objectFit": "contain",
      "borderRadius": "0.4286rem",
      "boxShadow": "var(--shadow-sm)"
    },
    ".md-img-caption": {
      "display": "block",
      "fontSize": "0.85em",
      "color": "hsl(var(--copy-muted))",
      "paddingTop": "0.35em"
    },
    ".md-root > :first-child": {
      "marginTop": "0"
    },
    ".md-root > :last-child": {
      "marginBottom": "0"
    },
    ".md-li > .md-p": {
      "marginBottom": "0"
    },
    ".md-blockquote > :last-child, .md-alert > :last-child": {
      "marginBottom": "0"
    },
    ".md-th[align=\"center\"], .md-td[align=\"center\"]": {
      "textAlign": "center"
    },
    ".md-th[align=\"right\"], .md-td[align=\"right\"]": {
      "textAlign": "right"
    },
    ".md-table-wrap[data-overflow-right=\"true\"]": {
      "maskImage": "linear-gradient(to right, black calc(100% - 2.5em), transparent)"
    },
    ".md-table-wrap[data-overflow-left=\"true\"]": {
      "maskImage": "linear-gradient(to left, black calc(100% - 2.5em), transparent)"
    },
    ".md-table-wrap[data-overflow-left=\"true\"][data-overflow-right=\"true\"]": {
      "maskImage": "linear-gradient(to right, transparent, black 2.5em, black calc(100% - 2.5em), transparent)"
    }
  }
}
